import { useContext } from 'react';
import { GlobalModalContext } from '../contexts/global-modal/GlobalModalContext';

export const useGlobalModal = () => useContext(GlobalModalContext);
